import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const NotFound = () => {
  return (
    <Wrapper>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>

        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">404 Error</h1>
                </div>

                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>404 Page</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="rs-error-area section-space text-center"
        style={{ paddingTop: "120px", paddingBottom: "120px" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-8 col-md-10">
              <div className="rs-error-content">
                <div className="rs-error-thumb mb-40">
                  <h1 className="error-text">404</h1>
                </div>

                <h2
                  className="rs-error-title"
                  style={{ fontSize: "42px", fontWeight: "700" }}
                >
                  Oops! Page Not Found
                </h2>

                <p style={{ marginTop: "15px", marginBottom: "30px" }}>
                  The page you are looking for might have been removed, had its
                  name changed, or is temporarily unavailable.
                </p>

                <Link
                  to="/"
                  className="rs-btn has-theme-orange has-icon has-bg"
                >
                  Back To Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .error-text {
    font-size: 160px;
    font-weight: 900;
    color: #ea5501;
    letter-spacing: 10px;
    position: relative;
    display: inline-block;
    animation: float 3s ease-in-out infinite;
  }

  /* floating animation */
  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  /* glow effect */
  .error-text::before,
  .error-text::after {
    content: "404";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
  }

  .error-text::before {
    color: #ff0000;
    animation: glitchTop 1s infinite linear alternate-reverse;
  }

  .error-text::after {
    color: #ea5501;
    animation: glitchBottom 1.2s infinite linear alternate-reverse;
  }

  @keyframes glitchTop {
    0% {
      transform: translate(2px, -2px);
    }
    50% {
      transform: translate(-2px, 2px);
    }
    100% {
      transform: translate(2px, -2px);
    }
  }

  @keyframes glitchBottom {
    0% {
      transform: translate(-2px, 2px);
    }
    50% {
      transform: translate(2px, -2px);
    }
    100% {
      transform: translate(-2px, 2px);
    }
  }
`;

export default NotFound;
